<template>
    <v-card class="grey lighten-3 d-flex align-center mx-auto" width="140px" height="80px" hover @click="$emit('edit')">
        <v-card-text class="text-center">
            <div>{{text}}...</div>
            <div class="caption grey--text text--darken-1">(click to edit)</div>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: ['text']
}
</script>